import { FC } from 'react'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { formatUSCurrency } from 'helpers/formatHelpers'
import { currentCCLedgerSelector, currentCardSelector } from 'components/features/creditCard/creditCardStore/selectors'
import { CardStatus } from 'components/features/creditCard/creditCardPage/CardStatus/CardStatus'
import { CreditCardLedgerChart } from 'components/features/creditCard/creditCardPage/CreditCardLedgerChart/CreditCardLedgerChart'
import { BalanceDetailsPaneButton, CardDetailsPaneButton, CardMenuPaneButton } from 'components/features/pfm/Button/FloatingPaneButtons'
import Flex from 'components/atoms/Flex/Flex'
import LoadingOverlay from 'components/atoms/preloaders/LoadingOverlay'
import { LabeledElement } from 'components/atoms/LabeledElement/LabeledElement'
import { BALANCE_HINT, CREDIT_LIMIT_HINT, STATEMENT_BALANCE_HINT } from 'components/features/creditCard/creditCardStore/constants'

export const CardSummary: FC = () => {
  const card = useStoreSelector(currentCardSelector)
  const ledger = useStoreSelector(currentCCLedgerSelector)

  return !card || !ledger ? (
    <LoadingOverlay />
  ) : (
    <Flex>
      <Flex horizontal>
        <Flex horizontal>
          <CreditCardLedgerChart ledger={ ledger } hideMinimum vertical />
          <Flex>
            <LabeledElement
              label='Balance'
              hint={ BALANCE_HINT }
              element={
                <BalanceDetailsPaneButton component='h2' backButton={ null }>
                  { formatUSCurrency(ledger.current_balance, 'penny') }
                </BalanceDetailsPaneButton>
              }
              vertical
              align='left'
            />
            <LabeledElement
              label='Statement Balance'
              hint={ STATEMENT_BALANCE_HINT }
              element={ formatUSCurrency(ledger.statement_balance_remaining, 'penny') }
              vertical
              align='left'
            />
            <LabeledElement
              label='Credit Limit'
              hint={ CREDIT_LIMIT_HINT }
              element={ formatUSCurrency(ledger.credit_limit, 'penny') }
              vertical
              align='left'
            />
          </Flex>
        </Flex>
        <Flex gap='micro'>
          <CardDetailsPaneButton component='div' fullWidth backButton={ null }>
            <CardStatus
              status={ card.status }
              text={ '•••• •••• •••• ' + card.truncated_pan }
              iconSlug={ card.status === 'suspended' ? 'lock' : undefined }
            />
          </CardDetailsPaneButton>
        </Flex>
      </Flex>
      <CardMenuPaneButton text='Card Menu' style='hollow' iconSlug='hamburger' fullWidth />
    </Flex>
  )
}
